export default "__VITE_ASSET__CMc9zF5H__"